var Users = /** @class */ (function () {
    function Users(form) {
        this.Form = form;
        this.init();
    }
    Users.prototype.init = function () {
        jQuery(this.Form.querySelector('select.users')).ac_select2({
            placeholder: acp_layouts.users,
            multiple: true,
            theme: 'acs2',
            minimumInputLength: 0,
            escapeMarkup: function (text) {
                return jQuery('<div>' + text + '</div>').text();
            },
            ajax: {
                type: 'POST',
                url: ajaxurl,
                dataType: 'json',
                delay: 350,
                data: function (params) {
                    return {
                        action: 'acp_layout_get_users',
                        _ajax_nonce: AC._ajax_nonce,
                        search: params.term,
                        page: params.page
                    };
                },
                processResults: function (response) {
                    if (response) {
                        if (response.success && response.data) {
                            return response.data;
                        }
                    }
                    return { results: [] };
                },
                cache: true
            }
        });
    };
    return Users;
}());
export default Users;
